import { useState } from 'react';

export default function EmailCapture() {
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!firstName.trim() || !email.trim()) {
      setError('Veuillez remplir tous les champs.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Adresse email invalide.');
      return;
    }
    setError('');
    console.log('Email capture:', { firstName: firstName.trim(), email: email.trim() });
    setSubmitted(true);
  };

  return (
    <section style={{
      background: '#0a1628',
      padding: '4rem 0',
    }}>
      <div className="container" style={{ maxWidth: 640 }}>
        {submitted ? (
          <div style={{ textAlign: 'center', padding: '2rem 0' }}>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.5rem', color: '#fafaf8', marginBottom: '1rem' }}>
              Inscription confirmée
            </div>
            <p style={{ color: 'rgba(250,250,248,0.65)', fontSize: '0.95rem', lineHeight: 1.7 }}>
              Merci, {firstName}. Vous recevrez nos prochaines analyses du marché immobilier israélien directement par email.
            </p>
          </div>
        ) : (
          <>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <span style={{
                display: 'inline-block', marginBottom: '0.75rem',
                fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.14em',
                color: 'var(--color-accent)', fontWeight: 700,
              }}>
                Analyses de marché
              </span>
              <h2 style={{ color: '#fafaf8', fontFamily: 'var(--font-display)', fontSize: '1.75rem', marginBottom: '0.75rem' }}>
                Recevez nos analyses mensuelles du marché israélien
              </h2>
              <p style={{ color: 'rgba(250,250,248,0.6)', fontSize: '0.95rem', lineHeight: 1.7, maxWidth: 480, margin: '0 auto' }}>
                Prix, rendements, opportunités — une synthèse mensuelle réservée aux investisseurs francophones sérieux.
              </p>
            </div>

            <form onSubmit={handleSubmit} noValidate>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.875rem', marginBottom: '0.875rem' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: 'rgba(250,250,248,0.5)', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.4rem' }}>
                    Prénom
                  </label>
                  <input
                    type="text"
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    placeholder="Jean"
                    style={{
                      width: '100%', padding: '0.7rem 1rem',
                      background: 'rgba(255,255,255,0.07)',
                      border: '1px solid rgba(196,163,90,0.25)',
                      borderRadius: 'var(--radius-sm)',
                      color: '#fafaf8', fontSize: '0.9rem',
                      fontFamily: 'var(--font-body)',
                      outline: 'none', boxSizing: 'border-box',
                    }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: 'rgba(250,250,248,0.5)', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.4rem' }}>
                    Email
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="jean@exemple.com"
                    style={{
                      width: '100%', padding: '0.7rem 1rem',
                      background: 'rgba(255,255,255,0.07)',
                      border: '1px solid rgba(196,163,90,0.25)',
                      borderRadius: 'var(--radius-sm)',
                      color: '#fafaf8', fontSize: '0.9rem',
                      fontFamily: 'var(--font-body)',
                      outline: 'none', boxSizing: 'border-box',
                    }}
                  />
                </div>
              </div>

              {error && (
                <div style={{ fontSize: '0.82rem', color: '#f87171', marginBottom: '0.75rem' }}>{error}</div>
              )}

              <button
                type="submit"
                className="btn btn-accent btn-lg"
                style={{ width: '100%', justifyContent: 'center' }}>
                Recevoir les analyses
              </button>

              <p style={{ textAlign: 'center', fontSize: '0.72rem', color: 'rgba(250,250,248,0.35)', marginTop: '1rem', marginBottom: 0 }}>
                Données 100 % confidentielles. Désabonnement en 1 clic.
              </p>
            </form>
          </>
        )}
      </div>
    </section>
  );
}
